import React from "react";
import { getServerUri } from "../modules/uriUtility";
import _ from "lodash";
import DialogDeleteShell from "./DialogDeleteShell";

export default function dialogVideoDelete(props) {
  const file = _.get(props, "videoToDelete.file", "");
  const ext = file.includes(".") ? file.substring(file.lastIndexOf(".")) : "";
  const baseName = _.get(props, "videoToDelete.name") || file;
  const assetName = baseName && !baseName.includes(".") ? baseName + ext : baseName;

  const handleDelete = (progressID) => {
    return fetch(getServerUri("video/deleteOne"), {
      method: "DELETE",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        videoID: props.videoToDelete._id,
        progressID: progressID || "",
      }),
    }).then((response) => {
      if (response.status === 200) {
        let newVideos = _.cloneDeep(props.videos);
        newVideos.splice(
          newVideos.indexOf(newVideos.filter((video) => video._id === props.videoToDelete._id)[0]),
          1
        );
        props.deleteVideoFromVideos(props.videoToDelete._id);
        props.setVideos(newVideos);
        if (newVideos.length > 0) {
          if (props.videoToDelete._id === props.selectedVideoID) props.selectVideo(newVideos[0]._id);
        } else props.selectVideo("");
        props.createSnackbar("Video deleted", "success");
        props.onAfterDelete?.();
        return true;
      } else {
        response.text().then(console.log).catch(console.error);
        return false;
      }
    });
  };

  return (
    <DialogDeleteShell
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
      assetName={assetName}
      assetID={_.get(props, "videoToDelete._id")}
      assetFile={_.get(props, "videoToDelete.file")}
      assetType="video"
      onConfirmDelete={handleDelete}
      createSnackbar={props.createSnackbar}
      errorMessage="An error occurred deleting the video."
    />
  );
}
